import React, { ReactNode, useState } from 'react';
import styles from './Tooltip.module.scss';
import clsx from 'clsx';

export enum TooltipPosition {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  position?: TooltipPosition;
  show?: boolean;
  className?: string;
  tooltipClassName?: string;
  onHide?: () => void;
  overflowText?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = TooltipPosition.Top,
  show,
  className,
  tooltipClassName,
  onHide,
  overflowText = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const visible = show === true && isHovered;

  const handleMouseEnter = () => setIsHovered(true);

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (show) {
      onHide?.();
    }
  };

  return (
    <div
      className={clsx(styles.wrapper, className)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {visible && (
        <div
          className={clsx(
            styles.tooltip,
            styles[position],
            overflowText && styles.tooltipOverflow,
            tooltipClassName
          )}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
